module.exports = __webpack_public_path__ + "img/15.3938900b.jpg";